/**
 * React hook for reading a single feature flag with re-render on change.
 *
 * Returns `false` until the snapshot has loaded, which matches our
 * fail-closed posture (legacy code paths stay active until the new
 * spine is explicitly enabled per profile).
 */

import { useEffect, useState } from 'react';
import { featureFlags, type FlagKey } from '../services/featureFlags';

export function useFeatureFlag(key: FlagKey): boolean {
  const [value, setValue] = useState<boolean>(() => featureFlags.isOn(key));

  useEffect(() => {
    return featureFlags.subscribe((snapshot) => {
      setValue(snapshot[key] === true);
    });
  }, [key]);

  return value;
}
